import { connect } from '../../../common/components/runtime-context';
import UserAvatarImage from '../../components/user-avatar-image';
import { getCurrentUser } from '../../../common/store/current-user/current-user-selectors';

const mapStateToProps = (state) => ({
  user: getCurrentUser(state),
});

export default connect(mapStateToProps)(UserAvatarImage);
